/*
 *  Copyright (c) 2020.
 *  This file is part of the Compo B2B application.
 *  (c) Compo soft - Sergey Sukhenko <cyxenko@gmail.com>
 *  For the full copyright and license information, please view the LICENSE
 *  file that was distributed with this source code.
 */

import {Term} from './Term';

export interface Manufacturer {
  id?: number;
  header: string;
  syncUid: string;
  enabled: boolean;
  content: string;
  terms?: Term[];
  deleted?: boolean;
}
